import { render, staticRenderFns } from "./service-edits.vue?vue&type=template&id=d845efce&scoped=true"
import script from "./service-edits.vue?vue&type=script&lang=ts"
export * from "./service-edits.vue?vue&type=script&lang=ts"
import style0 from "./service-edits.vue?vue&type=style&index=0&id=d845efce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d845efce",
  null
  
)

export default component.exports